export default __webpack_public_path__ + "static/media/request-a-proposal-img.e98133c5.png";